"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var modify_visists_1 = require("./modify_visists");
var CreateRoutePlanner = function () {
    return (React.createElement("div", null,
        React.createElement(modify_visists_1.default, null)));
};
exports.default = CreateRoutePlanner;
